import { render, staticRenderFns } from "./FactPanel.vue?vue&type=template&id=50efe489&"
import script from "./FactPanel.vue?vue&type=script&lang=js&"
export * from "./FactPanel.vue?vue&type=script&lang=js&"
import style0 from "./FactPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports